module.exports = __webpack_public_path__ + "static/media/demo.c41d7f30.mp3";